import { createReducer } from "@reduxjs/toolkit"

import { setCurrentUser, setPvOption } from "./actions"

interface AuthState {
  currentUser: any
  pvOption: boolean
}

const reducer = createReducer(
  {
    currentUser: null,
    pvOption: false,
  } as AuthState,
  {
    [setCurrentUser.type]: (state, action: any) => {
      state.currentUser = action.payload
      state.pvOption = false
    },
    [setPvOption.type]: (state, action) => {
      state.pvOption = action.payload
    },
  },
)

export default reducer
